import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ProjectSearchBar({ searchValue, setSearchValue }) {
  const { t } = useTranslation();
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 12,
        marginBottom: 12,
      }}
    >
      {!isSearchOpen ? (
        <img
          src="/Images/search-icon.png"
          alt="search"
          onClick={() => setIsSearchOpen(true)}
          style={{ width: 32, height: 32, cursor: 'pointer' }}
        />
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, maxWidth: 320, width: '100%' }}>
          <div style={{ position: 'relative', flex: 1, display: 'flex', alignItems: 'center' }}>
            <img
              src="/Images/search-icon2.png"
              alt="search"
              style={{ position: 'absolute', left: 10, width: 16, height: 16, pointerEvents: 'none' }}
            />
            <input
              type="text"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder={t('Rechercher')}
              style={{
                width: '100%',
                padding: '8px 36px 8px 34px',
                border: '1px solid #E5E7EB',
                borderRadius: 6,
                fontSize: 14,
                outline: 'none',
              }}
            />
          </div>
          <button
            type="button"
            onClick={() => {
              setIsSearchOpen(false);
              setSearchValue('');
            }}
            style={{
              background: '#F9FAFB',
              border: '1px solid #E5E7EB',
              borderRadius: 6,
              padding: '6px 10px',
              cursor: 'pointer',
              fontSize: 13,
              color: '#111827',
            }}
          >
            {t('Fermer')}
          </button>
        </div>
      )}
    </div>
  );
}
